/**
 * Aramaya hazirlik: Turkce karakterler Latin'e, kucuk harf, fazla bosluklar tek bosluga.
 * (upstream f599215)
 */
export const normalizeForSearch = (text: string): string => {
  if (!text) return "";
  return text
    .replace(/İ/g, "i")
    .replace(/I/g, "i")
    .replace(/ı/g, "i")
    .replace(/Ğ/g, "g")
    .replace(/ğ/g, "g")
    .replace(/Ü/g, "u")
    .replace(/ü/g, "u")
    .replace(/Ş/g, "s")
    .replace(/ş/g, "s")
    .replace(/Ö/g, "o")
    .replace(/ö/g, "o")
    .replace(/Ç/g, "c")
    .replace(/ç/g, "c")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
};

/**
 * Arama metnindeki her kelime haystack icinde geciyorsa true.
 * Sira ve bosluk sayisi onemsiz.
 */
export const matchesSearchTokens = (
  haystack: string | null | undefined,
  query: string | null | undefined,
): boolean => {
  const tokens = normalizeForSearch(query || "")
    .split(" ")
    .filter(Boolean);
  if (tokens.length === 0) return true;
  const normalizedHaystack = normalizeForSearch(haystack || "");
  return tokens.every((token) => normalizedHaystack.includes(token));
};

/**
 * Arama metnindeki her kelime verilen alanlardan EN AZ BIRINDE geciyorsa true.
 */
export const matchesSearchTokensInFields = (
  fields: Array<string | null | undefined>,
  query: string | null | undefined,
): boolean => {
  const tokens = normalizeForSearch(query || "")
    .split(" ")
    .filter(Boolean);
  if (tokens.length === 0) return true;
  const normalizedFields = fields.map((field) => normalizeForSearch(field || ""));
  return tokens.every((token) =>
    normalizedFields.some((field) => field.includes(token)),
  );
};

/**
 * Converts Turkish characters to Latin characters
 * @param text - The text to convert
 * @returns The converted text
 */
export const turkishToLatin = (text: string): string => {
  const charMap: { [key: string]: string } = {
    'ş': 's', 'Ş': 'S',
    'ı': 'i', 'İ': 'I',
    'ğ': 'g', 'Ğ': 'G',
    'ü': 'u', 'Ü': 'U',
    'ö': 'o', 'Ö': 'O',
    'ç': 'c', 'Ç': 'C'
  };

  return text.replace(/[şŞıİğĞüÜöÖçÇ]/g, match => charMap[match] || match);
};


/**
 * Capitalizes the first letter of each word in a string
 * @param text - The text to capitalize
 * @returns The text with first letter of each word capitalized
 */
export const toTitleCase = (text: string): string => {
  if (!text) return text;
  return text
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Capitalizes the first letter of each word in a string (Turkish-aware)
 * Uses toLocaleUpperCase/toLocaleLowerCase with 'tr-TR' locale for proper Turkish character handling
 * @param text - The text to capitalize
 * @returns The text with first letter of each word capitalized (Turkish characters handled correctly)
 */
export const toTitleCaseTR = (text: string): string => {
  if (!text) return text;
  return text
    .split(' ')
    .map(word => {
      if (!word) return word;
      const firstChar = word.charAt(0).toLocaleUpperCase('tr-TR');
      const rest = word.slice(1).toLocaleLowerCase('tr-TR');
      return firstChar + rest;
    })
    .join(' ');
};

// String extension: toTitleCase
declare global {
  interface String {
    toTitleCase(): string;
    toTitleCaseTR(): string;
  }
}

String.prototype.toTitleCase = function (): string {
  if (!this) return this;
  return this
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

String.prototype.toTitleCaseTR = function (): string {
  if (!this) return this;
  return this
    .split(' ')
    .map(word => {
      if (!word) return word;
      const firstChar = word.charAt(0).toLocaleUpperCase('tr-TR');
      const rest = word.slice(1).toLocaleLowerCase('tr-TR');
      return firstChar + rest;
    })
    .join(' ');
};